module.exports = __webpack_public_path__ + "static/media/ppt.7f9ec353.svg";